/**
 * ODDFISH — Site-wide native lazy loading for images missing a loading attribute.
 * LCP / above-fold heroes stay eager via loading="eager" or data-lcp="true".
 */
(function () {
  "use strict";

  var EAGER_SELECTORS = [
    ".oddfish-brand-logo-side img",
    ".oddfish-first-section__bg",
    ".single_blog_post .blog_header .right_side img",
    ".single_case_banner .banner_image > img",
    "[data-lcp-image]",
    "[data-lcp='true']"
  ];

  function isLcpCandidate(img) {
    if (!(img instanceof HTMLImageElement)) return false;
    if (img.getAttribute("loading") === "eager") return true;
    if (img.dataset.lcp === "true") return true;

    for (var i = 0; i < EAGER_SELECTORS.length; i++) {
      if (img.matches(EAGER_SELECTORS[i])) return true;
    }

    return false;
  }

  function applyLazy(img) {
    if (!(img instanceof HTMLImageElement)) return;
    if (img.hasAttribute("loading")) return;

    if (isLcpCandidate(img)) {
      img.loading = "eager";
      if (!img.hasAttribute("decoding")) img.decoding = "async";
      return;
    }

    img.loading = "lazy";
    if (!img.hasAttribute("decoding")) img.decoding = "async";
  }

  function scan(root) {
    if (!root) return;

    if (root instanceof HTMLImageElement) {
      applyLazy(root);
      return;
    }

    if (root.querySelectorAll) {
      root.querySelectorAll("img").forEach(applyLazy);
    }
  }

  function initObserver() {
    if (!("MutationObserver" in window)) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          scan(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  initObserver();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    scan(event.target);
  });
})();
